var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.707 0.293214C15.5194 0.105742 15.2651 0.000427237 15 0.000427234C14.7348 0.000427231 14.4805 0.105742 14.293 0.293214L7.99997 6.58621L1.70697 0.293214C1.51837 0.111055 1.26577 0.0102614 1.00357 0.0125397C0.741372 0.014818 0.490559 0.119987 0.305151 0.305395C0.119743 0.490803 0.0145732 0.741616 0.0122949 1.00381C0.0100165 1.26601 0.11081 1.51861 0.292969 1.70721L7.29297 8.70721C7.4805 8.89468 7.73481 9 7.99997 9C8.26513 9 8.51944 8.89468 8.70697 8.70721L15.707 1.70721C15.8944 1.51969 15.9998 1.26538 15.9998 1.00021C15.9998 0.735049 15.8944 0.480741 15.707 0.293214Z","fill":"#3D2B30"}));
}

ArrowDown.defaultProps = {"width":"16","height":"9","viewBox":"0 0 16 9","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
